export default __webpack_public_path__ + "static/media/team-call.6f1c3958.mp3";